import React, { useEffect } from 'react';
import "./style.css";
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { getLocalStorage } from '../../utils/localStorage';
import { FaListOl } from 'react-icons/fa';
import { BsListNested } from 'react-icons/bs';
import lockImg from "../../data/lock.png";

function TeleCallerPlatfomMain(props) {
    const { pathname } = useLocation();
    const { role, email } = getLocalStorage("CURRENT_USER");
    const RestrictedPage = () => {
        const navigate = useNavigate();
        useEffect(() => {
            setTimeout(() => {
                navigate(-1)
            }, 2000);
        }, [])

        return (<>
            <div className="restrcited-page" >
                <div className="restrcited-page-inner">
                    <div className="restrcited-page-img" >
                        <img src={lockImg} style={{ height: 125, width: 125 }} alt="restrictedpage" />
                    </div>
                    <p className="restrcited-page-p">You don't have permission to view this page</p>
                </div>
            </div>
        </>)
    }
      const CheckPermission = () => {
   
           const links = [
   
             
   
           ]
   
           let list = [];
           for (let obj of links) {
               // Check if any role in the role array matches any permission in the Permissions array
               if (role.some(r => obj.Permissions.includes(r))) {
                   let innerList = [];
                   for (let key of obj.links) {
                       // Check if any role in the role array is allowed for the link
                       if (role.some(r => key.allowed.includes(r))) {
                           innerList.push(key);
                       }
                   }
                   let tempObj = obj;
                   tempObj.links = innerList;
                   list.push(tempObj);
               }
           }
           return list;
       }
   
       const checkActivePath = (screen) => {
           const str = pathname.split("/");
           const path = screen.split("/")
           if (
               str[0] === path[0] &&
               str[1] === path[1] &&
               str[2] === path[2] &&
               str[3] === path[3]) {
               return true;
           } else {
               return false;
           }
   
       }
   
   
       return (
           <>
               {email.split('@')[1] === 'theduefactory.com' ? (<>
                   <div style={{ marginTop: 0, overflow: "hidden", fontFamily: "gb Regular" }}>
   
                       {CheckPermission().map((item) => (
   
                           <div key={item.title} className='pa-top-bar'>
                               {item.links.map((link) => (
                                   <NavLink
                                       className="pa-CustomLink"
                                       to={`${link.path}`}
                                       key={link.name}
                                       style={
                                           checkActivePath(link.path) ?
                                               {
                                                   backgroundColor: "#1fafe5ff",
                                                   color: "#fff",
                                                   fontWeight: 800,
                                               } : {
                                                   backgroundColor: '#fff',
                                                   color: 'rgb(96 82 82',
                                                   fontWeight: 800,
                                               }
                                       }
   
                                   >
                                       {link.icon}
                                       <span className="capitalize ">{link.name}</span>
                                   </NavLink>
                               ))}
                           </div>
   
                       ))}
                       <div >
                           <Outlet ></Outlet>
                       </div>
   
                   </div>
               </>) : (<>
                   <RestrictedPage />
               </>)}
           </>
       )
}

export default TeleCallerPlatfomMain